import { get, set } from 'lodash'
import { required, email } from 'utils/validation'

const validate = values => {
  let errors = {}

  set(errors, 'countryId', null)
  errors.countryId = required(get(values, 'countryId'))
  errors.organizationId = required(get(values, 'organizationId'))

  errors = {
    ...errors,
    helpers: {
      ...errors.helpers,
      knownLeader: required(get(values, 'helpers.knownLeader'))
    }
  }

  if (get(values, 'helpers.knownLeader') === 'yes') {
    errors = {
      ...errors,
      helpers: {
        ...errors.helpers,
        awardLeaderEmail: required(get(values, 'helpers.awardLeaderEmail')) ||
          email(get(values, 'helpers.awardLeaderEmail'))
      }
    }
  }

  return errors
}

export default validate
